/** P5 route (Bank): the round-start position and every released round's report (each carries its quarterly statements and attribution). */
import { useQueryClient } from "@tanstack/react-query";
import { useRoute } from "../api/context";
import { useYearsBefore } from "../decisions/drivers/useDriverYears";
import { useCohortData } from "../shell/data";
import { GxErrorBanner } from "../theme/primitives";
import { Financials, FinancialsSkeleton } from "./Financials";

export function FinancialsPage({ cohortId, teamId }: { readonly cohortId: string; readonly teamId: string | null }) {
  const data = useCohortData(cohortId, teamId, "all");
  const queryClient = useQueryClient();
  const position = useRoute("bankPosition", teamId === null ? null : { teamId });
  const yearsBefore = useYearsBefore(teamId, data.status === "ready" ? data.catalog : undefined);
  if (data.status === "no-team") return <GxErrorBanner message="Your facilitator hasn't placed you on a team yet." />;
  if (data.error !== null) return <GxErrorBanner error={data.error} />;
  if (data.status === "loading") return <FinancialsSkeleton />;
  return <Financials team={data.team} catalog={data.catalog} market={data.market} reports={data.reports} yearsBefore={yearsBefore} {...(position.data === undefined ? {} : { position: position.data })} onRetry={() => void queryClient.invalidateQueries({ queryKey: ["roundReport"] })} />;
}
